




























































import Vue from 'vue'
import BucketSelector from '@/components/BucketSelector.vue'
import Button from '@/types/components/Button.interface'
import { mapGetters } from 'vuex'
import multiselectMixin from '@/mixins/multiselect-mixin'
import UserSelector from '@/components/UserSelector.vue'
export default Vue.extend({
    mixins: [multiselectMixin],
    components: { BucketSelector, UserSelector },
    props: {
        channelIds: {
            type: Array,
            required: true
        },
        conversationCount: {
            type: Number,
            required: true
        },
        currentGroup: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        groupName: {
            type: String,
            required: false,
            default: null
        },
        target: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            // The v-model for the loading spinner on buttons
            loading: null,
            //  Determines if we will remove from a view after adding
            remove: null,
            // The current step we are in the v-stepper
            step: 1,
        }
    },
    computed: {
        ...mapGetters(['users']),
        buttons(): Button[] {
            const buttons: Button[] = [
                {
                    text: 'Assign to teammate',
                    icon: 'bi-person-circle',
                    callback: () => this.setStep(2)
                },
                {
                    text: 'Mark as New',
                    icon: 'bi-exclamation-circle-fill',
                    callback: () => this.markAsNew()
                },
                {
                    text: 'Add to view',
                    icon: 'bi-folder-plus',
                    callback: () => (this.groupName ? this.setStep(3) : this.setStep(4))
                },
                {
                    text: 'Send Message',
                    icon: 'bi-megaphone-fill',
                    callback: () => this.startBroadcast(this.channelIds),
                    color: this.planType()
                }
            ]

            //  return buttons
            return buttons
        },
        addToViewButtons(): Button[] {
            const buttons: Button[] = [
                {
                    text: 'Add to view',
                    icon: 'bi-folder-plus',
                    callback: () => this.setStep(4)
                },
                {
                    text: 'Add to view and remove from current',
                    icon: 'bi-folder-symlink-fill',
                    callback: () => this.addAndRemove()
                },
                {
                    text: 'Remove from view',
                    icon: 'bi-folder-x',
                    callback: () => this.removeFromBucket()
                }
            ]
            //  return buttons
            return buttons
        }
    },
    methods: {
        addAndRemove(): void {
            //  Set our remove boolean to true
            this.remove = true

            //  Set our step to 4
            this.setStep(4)
        },
        clear(): void {
            this.target.selectPageReset()
        },
        //  Sets the color of a button depending on the plan
        planType(): string {
            //  Get the stripe plan from the subscription
            const plan = this.$store.getters.plan

            //  If no plan, return nothing
            if (!plan) return null

            //  If product tier not specified, return null
            if (!plan.metadata || !plan.metadata.product_tier) return null

            //  If plan type is starter, return grey
            if (plan.metadata.product_tier == 'Starter') return 'grey'
        },
        selectAll(): void {
            this.target.selectPage()
        }
    },
    watch: {
        step(val: number): void {
            //  If the value is ever 1, set remove to false
            if (val === 1) this.remove = false
        }
    }
})
